import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;
  constructor(props) {
      super(props);
      this.state = {
          activeApp: ""
      };
    }

    updateActiveApp(activeApp) {
        this.setState({
            activeApp: activeApp
        });
    }


  render () {
    return (
      <div>
        <NavMenu
            activeApp={this.state.activeApp}
            logout={this.props.logout}
            userName={this.props.userName}
            userId={this.props.userId}
            userPermissions={this.props.userPermissions}
            appPermissions={this.props.appPermissions}
        />
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
